module.exports = __webpack_public_path__ + "static/media/LineVerticalBlueColor.eddcb002.svg";